import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import {
  GettingStartedTransferFundsIcon,
  GettingStartedTransferFundsMobileIcon,
} from '../../icons/GettingStartedDepositFundsIcon'
import {
  GettingStartedDepositIcon,
  GettingStartedDepositMobileIcon,
} from '../../icons/GettingStartedDepositIcon'
import {
  GettingStartedEmailIcon,
  GettingStartedEmailMobileIcon,
} from '../../icons/GettingStartedEmailIcon'
import {
  GettingStartedSubscribeMarketDataIcon,
  GettingStartedSubscribeMarketDataMobileIcon,
} from '../../icons/GettingStartedSubscribeMarketDataIcon'
import {
  GettingStartedSubscribePlatformIcon,
  GettingStartedSubscribePlatformMobileIcon,
} from '../../icons/GettingStartedSubscribePlatformIcon'
import { useWindowResize } from '../../utils/domUtils'
import { useScrollToTopOnRouteChange } from '../../utils/useScrollToTop'
import { Accordion, AccordionList } from './Accordion'

export const GettingStartedETDPage = (): JSX.Element => {
  useScrollToTopOnRouteChange()
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  return (
    <AccordionList>
      <Accordion
        title={t('Learning.Fund your Tickmill Wallet')}
        subtitle={t('Fund your Tickmill Wallet')}
        text={t('Min. 1,000 USD or equivalent in GBP, EUR, HKD, SGD and CHF')}
        icon={isMobile ? <GettingStartedDepositMobileIcon /> : <GettingStartedDepositIcon />}
        buttonText={t('Learning.Start Deposit')}
        path={'/dashboard/traders-room/wallets/deposit'}
        accordionId='fund-your-tickmill-wallet'
      />
      <Accordion
        title={t('Learning.Transfer funds from Wallet to Trading Account step')}
        subtitle={
          isMobile
            ? t(
                'Learning.Please note that the payment for the required trading platform and market'
              )
            : ''
        }
        text={
          isMobile
            ? ''
            : t(
                'Learning.Please note that the payment for the required trading platform and market'
              )
        }
        icon={
          isMobile ? <GettingStartedTransferFundsMobileIcon /> : <GettingStartedTransferFundsIcon />
        }
        buttonText={t('Transactions.Start Transfer')}
        path={'/dashboard/traders-room/wallets/transfer'}
        accordionId='start-transfer'
      />
      <Accordion
        title={t('Learning.Subscribe to Trading Platform title')}
        subtitle={t('Learning.Subscribe to Trading Platform')}
        icon={
          isMobile ? (
            <GettingStartedSubscribePlatformMobileIcon />
          ) : (
            <GettingStartedSubscribePlatformIcon />
          )
        }
        buttonText={t('Learning.Subscribe')}
        path={'/dashboard/subscriptions/trading-platforms'}
        accordionId='subscribe-to-trading-platform'
      />
      <Accordion
        title={t('Learning.Subscribe to Market Data title')}
        subtitle={t('Learning.Subscribe to Market Data')}
        icon={
          isMobile ? (
            <GettingStartedSubscribeMarketDataMobileIcon />
          ) : (
            <GettingStartedSubscribeMarketDataIcon />
          )
        }
        buttonText={t('Learning.Subscribe')}
        path={'/dashboard/subscriptions/market-data'}
        accordionId='subscribe-to-market-data'
      />
      <Accordion
        title={t(
          'Learning.Check your email for instructions on how to connect to a third party platform title'
        )}
        subtitle={
          isMobile
            ? ''
            : t(
                'Learning.Check your email for instructions on how to connect to a third party platform'
              )
        }
        icon={isMobile ? <GettingStartedEmailMobileIcon /> : <GettingStartedEmailIcon />}
        accordionId='instructions-to-connect-third-party-platform'
      />
    </AccordionList>
  )
}
